module.exports = __webpack_public_path__ + "img/christelle-bruyere.94eb59a6.jpg";